module.exports = __webpack_public_path__ + "assets/img/c23.fbe85872.png";